import { BehaviorSubject, filter, Observable } from 'rxjs';
import { QtControlAdapter } from './qt-control-adapter';

export interface ColumnConfig {
  /** colId → visible */
  visibility: Record<string, boolean>;
  /** colId → px width */
  widths: Record<string, number>;
}

export class ColumnConfigAdapter implements QtControlAdapter<ColumnConfig> {
  readonly key = 'columns';

  private _suppress = false;
  private readonly _state$ = new BehaviorSubject<ColumnConfig>({
    visibility: {},
    widths: {},
  });

  readonly valueChanges$: Observable<ColumnConfig> = this._state$.pipe(
    filter(() => !this._suppress)
  );

  /** Consume in templates to drive column visibility/width. */
  readonly state$ = this._state$.asObservable();

  setVisibility(colId: string, visible: boolean): void {
    const s = this._state$.getValue();
    this._state$.next({
      ...s,
      visibility: { ...s.visibility, [colId]: visible },
    });
  }

  setWidth(colId: string, width: number): void {
    const s = this._state$.getValue();
    this._state$.next({
      ...s,
      widths: { ...s.widths, [colId]: width },
    });
  }

  applyValue(value: ColumnConfig): void {
    this._suppress = true;
    this._state$.next(value);
    this._suppress = false;
  }

  getValue(): ColumnConfig {
    return this._state$.getValue();
  }
}
